import { render } from "./YunpianShotLink.vue?vue&type=template&id=553633a9&scoped=true"
import script from "./YunpianShotLink.vue?vue&type=script&lang=js"
export * from "./YunpianShotLink.vue?vue&type=script&lang=js"

import "./YunpianShotLink.vue?vue&type=style&index=0&id=553633a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553633a9"]])

export default __exports__